import React from 'react';
import FlexCenterCenter from "./FlexCenterCenter";
import SpinnerApple from "../spinner/Spinner.Apple";
import NoRecordsFound from "../../no-records/NoRecordsFound";
import PropTypes from "prop-types";
export default function LoadableObjContainer(props) {
  if (props.obj === void 0 || props.obj === null) {
    return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, null));
  }
  if (props.obj) {
    var _props$children;
    return props.obj.id ? (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null : /*#__PURE__*/React.createElement(NoRecordsFound, {
      message: props.noRecordsFoundMsg,
      caption: props.noRecordsFoundCaption
    });
  }
}
LoadableObjContainer.propTypes = {
  obj: PropTypes.any,
  noRecordsFoundMsg: PropTypes.string,
  noRecordsFoundCaption: PropTypes.string
};
LoadableObjContainer.defaultProps = {
  noRecordsFoundsMsg: "Record not found."
};